import { NIVEL_SUPERIOR, NIVEL_TECNICO } from 'types/NivelCbo'

export const grupoCboFolhaRostoOdontologico = [...NIVEL_SUPERIOR, ...NIVEL_TECNICO]
